// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__295yw","clickedWithMouse":"MenuLabel_clickedWithMouse__zP2MC","isOpen":"MenuLabel_isOpen__3r7Or"};